import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TipoActividad } from 'src/app/app.config/app.config-beneficios'; // Modelo de TipoActividad
import { TipoActividadService } from '@services/tipo-actividad.service'; // Importar el servicio
import { Router } from '@angular/router';

@Component({
  selector: 'app-listado-categoria',
  templateUrl: './listado-categoria.component.html',
  styleUrls: ['./listado-categoria.component.scss'],
})
export class ListadoCategoriaComponent implements OnInit {
  /* Data Table*/
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['denominacion', '_id'];
  dataSource: any;
  flagLoaded = false;
  categorias: TipoActividad[] = [];

  /* Modales custom (reemplazo de SweetAlert) */
  showEliminarModal = false;
  showEliminadaModal = false;
  showErrorEliminarModal = false;
  categoriaAEliminar: string | null = null;

  constructor(private tipoActividadService: TipoActividadService,
              private router: Router) {} // Inyectamos el servicio TipoActividadService

  ngOnInit(): void {
    this.loadDataPage(); // Cargamos los datos al inicializar el componente
  }

  async loadDataTable(): Promise<void> {
    await this.tipoActividadService.obtenerTipoActividades().toPromise().then((categorias: TipoActividad[]) => {
      // Filtramos excluyendo el ID de Noticias
      const categoriasFiltradas = categorias.filter(item => item._id !== '679bd689a9a18a04209c41a0');
      
      this.dataSource = new MatTableDataSource(categoriasFiltradas);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }   

  // Método para filtrar los datos de la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  verCategoria(event): void {
    this.tipoActividadService.getTipoActividadById(event).subscribe(categoria => {
      this.router.navigateByUrl('/modificacion-categoria');
      this.tipoActividadService.setCategoriaSeleccionada(categoria);
    });
  }

  async loadDataPage() {
    await this.loadDataTable();
    this.flagLoaded = true;
    return;
  }

  eliminarCategoria(id: string) {
    this.categoriaAEliminar = id;
    this.showEliminarModal = true;
  }

  async confirmarEliminar() {
    const id = this.categoriaAEliminar;
    this.showEliminarModal = false;

    if (!id) {
      return;
    }

    const eliminado = await this.tipoActividadService.delete(id);
    this.categoriaAEliminar = null;

    if (eliminado) {
      this.showEliminadaModal = true;
      await this.loadDataPage();
    } else {
      this.showErrorEliminarModal = true;
    }
  }

}
